var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEnviromentSwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10.5,
    viewBox: "0 0 12 10.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.165-2.085-2.04-3.96a.563.563,0,0,0-.96.4v.937h-.75L-4.987-3.95l-1.25,1.339L-4.583-.839a.28.28,0,0,0,.206.089H-3V.187a.563.563,0,0,0,.96.4L-.165-1.29A.562.562,0,0,0-.165-2.085Zm-11.554-4.29H-9.75L-8.513-5.05l1.25-1.339L-8.917-8.161a.28.28,0,0,0-.206-.089h-2.6A.281.281,0,0,0-12-7.969v1.313A.281.281,0,0,0-11.719-6.375Zm8.719,0v.937a.563.563,0,0,0,.96.4L-.165-6.915a.562.562,0,0,0,0-.8L-2.04-9.585a.563.563,0,0,0-.96.4v.937H-4.378a.28.28,0,0,0-.206.089L-9.75-2.625h-1.969A.281.281,0,0,0-12-2.344v1.313a.281.281,0,0,0,.281.281h2.6a.281.281,0,0,0,.206-.089L-3.75-6.375Z",
    transform: "translate(12 9.75)",
    fill: "#fff",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEnviromentSwitch);
export default __webpack_public_path__ + "static/media/icons_EnviromentSwitch.30be444b716fae415fb41c065a0168c6.svg";
export { ForwardRef as ReactComponent };